import { createSlice } from "@reduxjs/toolkit";

const initialInventoryStatusState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  inventoryStatusForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const inventoryStatusSlice = createSlice({
  name: "inventorystatus",
  initialState: initialInventoryStatusState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getInventoryStatusById
    inventoryStatusFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryStatusForEdit = action.payload.inventoryStatusForEdit;
      state.error = null;
    },
    // getInventoryStatusChart
    inventoryStatusChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryStatusChart = action.payload.inventoryStatusChart;
      state.error = null;
    },
    // getInventoryStatusChart
    inventoryStatusHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryStatusChartHour = action.payload.inventoryStatusChartHour;
      state.error = null;
    },
    // getInventoryStatusChart
    inventoryStatusHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryStatusChartHourZone =
        action.payload.inventoryStatusChartHourZone;
      state.error = null;
    },
    // get list data
    allInventoryStatusFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.inventoryStatusForEdit = undefined;
      state.floorPlans = undefined;
      state.inventoryStatusChart = undefined;
      state.inventoryStatusChartHour = undefined;
      state.inventoryStatusChartHourZone = undefined;
    },
    // createInventoryStatus
    inventoryStatusCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateInventoryStatus
    inventoryStatusUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // inventoryStatusDeleted
    inventoryStatusDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
